import styled from 'styled-components';
import NavBar from '../../molecules/navigations/NavBar';
import ContentSection from '../../atoms/sections/ContentSection';
import React, { useContext } from 'react';
import { PrismicContext } from '../../util/usePrismic';

const HeaderBlock = styled.p`
  font-size: ${({ theme }) => theme.fonts.medium};
  font-weight: bold;
  margin-top: 14px;
  margin-bottom: 7px;
`;

const TextBlock = styled.p`
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.textLightGray};
`;

const Wrapper = styled.div`
  margin: 30px 0;
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  @media (max-width: 900px) {
    justify-items: start;
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const AboutView = () => {

  const {aboutUs} = useContext(PrismicContext);

  return (
    <ContentSection>
      <NavBar />
      <Wrapper>
        <div>
          <HeaderBlock>
            Koło Naukowe Analiz Strategicznych
          </HeaderBlock>
          {
            aboutUs.aboutUsParagraphs.map(text => (
              <TextBlock className={'animate left-animate'} key={text}>
                {text}
              </TextBlock>
            ))
          }
        </div>
        <div>
          <HeaderBlock>
            {aboutUs.administrationTitle}
          </HeaderBlock>
          <TextBlock className={'animate left-animate'}>
            {
              aboutUs.administrationPersons.map(text => (
                <p key={text}>{text}</p>
              ))
            }
          </TextBlock>
          <HeaderBlock>Opiekun Koła Naukowego</HeaderBlock>
          <TextBlock className={'animate left-animate'}>
            {aboutUs.supervisor}
          </TextBlock>
        </div>
      </Wrapper>
    </ContentSection>
  );
};

export default AboutView;
